import { MenuItem } from '@material-ui/core'
import LinearProgress from '@material-ui/core/LinearProgress'
import { Theme, withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import i18n from 'i18next'
import { withTranslation } from 'react-i18next'
import { Field, reduxForm } from 'redux-form'
import SubmitFormButton from '../../../components/Buttons/SubmitFormButton'
import {
  ReduxFormField,
  ReduxPhoneField
} from '../../../components/FormInput/ReduxWrappers'
import { MuiClasses } from '../../../types'
import { required } from '../../../utils/validation/forms'
import FieldContainer from '../../Apartment/FieldContainer'

const styles = (theme: Theme) => ({
  button: {
    marginTop: theme.spacing(2)
  },
  leftIcon: {
    marginRight: theme.spacing()
  },
  phoneInput: {
    '& .react-tel-input': {
      '& .special-label': {
        fontFamily: 'CircularRegular'
      },
      '& input': {
        fontFamily: 'CircularRegular'
      }
    }
  }
})

type EditProfileInfoFormProps = {
  classes: MuiClasses
  handleSubmit: (arg: any) => any
  submitting: boolean
  updateUserInformation: (arg: any) => void
  error: string
  t: i18n.TFunction
}

const EditProfileInfoForm = ({
  handleSubmit,
  submitting,
  updateUserInformation,
  error,
  t,
  classes
}: EditProfileInfoFormProps) => (
  <form onSubmit={handleSubmit(updateUserInformation)}>
    <FieldContainer>
      <ReduxFormField
        name='name'
        label={t('editProfile.name')}
        validate={[required]}
        required
      />
    </FieldContainer>
    <div className={classes.phoneInput}>
      <Field
        fullWidth
        name='phone_number'
        label={t('editProfile.phone')}
        invalidLabel=''
        required
        validate={[required]}
        helperText={t('editProfile.phoneHelperText')}
        component={ReduxPhoneField}
      />
    </div>

    <div style={{ paddingTop: '10px' }}>
      <ReduxFormField
        name='custom:language'
        label={t('apartment.language')}
        validate={[required]}
        select
        required
      >
        <MenuItem value='fi'>{t('language.fi')}</MenuItem>
        <MenuItem value='en'>{t('language.en')}</MenuItem>
      </ReduxFormField>
    </div>
    {error && (
      <Typography style={{ color: 'red' }} variant='body1'>
        {error}
      </Typography>
    )}
    <SubmitFormButton submitting={submitting} fullWidth borderRadius='4px' />
    {submitting && <LinearProgress />}
  </form>
)

export default reduxForm({
  form: 'EditProfileInfoForm'
})(
  withStyles(styles)(withTranslation()(EditProfileInfoForm as any)) as any
) as any
